import { cssColors, defineCss, messageBox } from '@src/style/style';
import { makeButton } from './networkHelpers.js';
import MachineMotionApi from '@lib/networkApi.js';
import './networkWifiApp.css';

const wifiApp = {
  rightPane: null,
  uiLeft: null,
  uiRight: null,
  apps: null,
  name: 'Available WiFi Networks',
  isSelected: false,

  collapsed: true,

  // options is in the form of 'ssid-name' : { data: { encryption: false, connected: false, ssid:'ssid-name'}, ui: null},
  options: {},

  isWifiAvailable: false,

  selectedSsid: null,

  pollingCancellation: null,

  onChangeCb: null,
  onChange: function (cb) { this.onChangeCb = cb; },
  onUpdateCb: null,
  onUpdate: function (cb) { this.onUpdateCb = cb; },

  isAvailable: function () { return this.isWifiAvailable; },

  selectOption: function (pOption) {
    this.uiLeft.find('.app-option').removeClass('selected');

    if (!pOption) { return; }

    this.options[pOption].ui.addClass('selected');
    this.selectedSsid = pOption;
    this.apps.select(this.name);
    this.show();
  },

  makeIpInfo: function (pLabel, pValue) {
    const ui = $('<div>')
      .css({
        display: 'grid',
        'grid-template-columns': '2rem 1fr 1fr 2rem',
        width: '100%',
      })
      .append(
        $('<div>').text(pLabel).css({ 'grid-column': '2 / 3', 'place-self': 'start', 'font-weight': 700 }),
        $('<div>').text(pValue).css({ 'grid-column': '3 / 4', 'place-self': 'end' }),
      );
    return ui;
  },

  makeRightUI: function (pOption) {
    if (!this.isAvailable()) {
      return $('<div>').text('The connection to the Teach Pendant was lost.');
    }

    if (!pOption) {
      return $('<div>').text('No WiFi Network selected.');
    }

    if (!this.options[pOption]) {
      // Note: we should never hit this condition.
      console.warn('The selected option ' + pOption + 'is not part of the wifi options');
      console.log(this.options);
      return;
    }

    const lThis = this;
    defineCss('.title-spacing', 'margin-bottom: 12px;');

    // taken from machinelogic_styles.css
    defineCss('.ml_select_widget', 'position: relative; height: 2.5rem; font-size: 0.9rem;');
    defineCss('.ml_select_widget::after', 'content: "\\f078"; font-size: 0.7rem; font-family: "Font Awesome 5 Pro"; right: 11px; height: inherit; padding: 0 0 0 8px; position: absolute; pointer-events: none; display: flex; align-items: center;');
    defineCss('.ml_select_widget select', '-webkit-appearance: none; -moz-appearance: none; appearance: none; height: inherit; display: block; background-color: white; width: 100%; float: right; padding: 0 1.5rem 0 0.5rem; border: 1px solid #CFCFCF; border-radius: 0.15rem;');
    defineCss('.ml_select_widget select:focus', 'border: 1px solid #1C344F !important; outline: none;');

    defineCss('.wifi-input > input', `flex-grow: 1; border: 1px solid ${cssColors.border_color}; border-radius: 3px; box-shadow: none; width:5rem`);
    defineCss('.wifi-input input:disabled', 'background-color: #E2E2E2;');

    const ui = $('<div class="app-right">').append(
      $('<div class="network-bold center-column bigger" id="wifi-setting-title">').text('WiFi Settings').css({ 'margin-bottom': '2rem' }),
    );

    if (!this.options[pOption].data.connected) {
      ui.append($('<div class="network-bold center-column bigger">')
        .text(this.options[pOption].data.encryption
          ? `The WiFi network “${pOption}“ requires a password`
          : `Connect to “${pOption}“ network`,
        ));
    }

    const subUi = $('<div class="app-right-card-container  app-right-card-inner">').css({
      margin: 'auto',
      gap: '28px',
      display: 'flex',
      'flex-direction': 'column',
      'margin-top': '1rem',
    });

    if (this.options[pOption].data.connected) {
      this.disconnectButton = $('<button class="red-button">')
        .css({ width: '100%' })
        .text('Disconnect')
        .click(function () {
          messageBox('Disconnection in progress, this might take some time.', 'info');
          lThis.wifiDisconnnect();
        });

      subUi.append(
        $('<div class="network-bold center-column">').text(pOption).css({ 'margin-bottom': '0rem', 'justify-content': 'center' }),
        this.makeIpInfo('IP', this.options[pOption].data.ip || 'unavailable'),
        this.makeIpInfo('Netmask', this.options[pOption].data.netmask || 'unavailable'),
        this.makeIpInfo('Gateway', this.options[pOption].data.gateway || 'unavailable'),
        this.disconnectButton,
      );
    }
    else {
      // 1. Network-specific connection request
      // show password field
      if (this.options[pOption].data.encryption) {
        const toggleShowPassword = (passwordInput, showPasswordToggle) => {
          const passwordInputType = passwordInput.attr('type');
          if (passwordInputType === 'password') {
            showPasswordToggle.removeClass('icon-make-visible');
            showPasswordToggle.addClass('icon-make-invisible');
            passwordInput.attr('type', 'text');
          }
          else if (passwordInputType === 'text') {
            showPasswordToggle.removeClass('icon-make-invisible');
            showPasswordToggle.addClass('icon-make-visible');
            passwordInput.attr('type', 'password');
          }
        };
        const passwordInput = $('<input type="password" class="wifi_connection_password_input network-input keyboard">');
        const showPasswordToggle = $('<div class="wifi_connection_show_password_toggle icon-make-visible">').on('click', () => { toggleShowPassword(passwordInput, showPasswordToggle); });
        const passwordInputWithShowPasswordToggle = $('<div class="password_input_with_show_password_toggle">').append(
          passwordInput,
          showPasswordToggle,
        );

        subUi.append(
          $('<div class="wifi-input">').append(
            $('<div class="network-bold title-spacing">').text('Password:'),
            passwordInputWithShowPasswordToggle,
          ),
        );
      }

      this.connectButton = $('<button class="blue-button title-spacing">')
        .css({ width: '100%', 'margin-top': '0rem' })
        .text('Connect')
        .click(function () {
          const password = subUi.find('.wifi-input input').val();
          // when network is encrypted, the user must provide a password
          const missingPassword = lThis.options[pOption].data.encryption ? !password : false;
          if (missingPassword) {
            messageBox('Please enter a password before connecting.', 'warning');
          }
          else {
            messageBox('WiFi connection in progress, this might take some time.', 'info');
            lThis.wifiConnect(pOption, password);
          }
        });

      subUi.append(this.connectButton);
    }

    ui.append(subUi);

    this.onChangeCb && this.onChangeCb('right', ui);
    return ui;
  },

  wifiDisconnnect: function () {
    this.disconnectButton.attr('disabled', true);

    MachineMotionApi.wifi.disconnect(
      (data) => {
        this.disconnectButton.attr('disabled', false);
        if (!data.error) { this.update('onDisconnect'); }
      },
      () => { this.disconnectButton.attr('disabled', false); }, // should not really happen
    );
  },

  wifiConnect: function (pSSID, pPassword) {
    // NOTE: scanning while connecting is not possible, we will prevent it
    this.refreshButton.enable(false);
    this.connectButton.attr('disabled', true);

    MachineMotionApi.wifi.connect(pSSID, pPassword,
      (data) => {
        this.refreshButton.enable(true);
        this.connectButton.attr('disabled', false);

        // Update networks variable and refresh gui display
        if (data && !data.error) {
          this.update('onConnect', data.currentWifiSsid);
        }
        else {
          console.error('wifiConnect error : ' + (data ? JSON.stringify(data.error) : ''));
          messageBox('Connection to ' + pSSID + ' failed.', 'error');
        }
      },
      (data) => {
        messageBox('Connection to ' + pSSID + ' failed.', 'error');
        this.refreshButton.enable(true);
        this.connectButton.attr('disabled', false);
      },
    );
  },

  show: function () {
    if (!this.isSelected) { return; }

    this.rightPane.empty();
    this.uiRight = this.makeRightUI(this.selectedSsid);
    this.rightPane.append(this.uiRight);
  },

  _remove: function () {
    if (this.uiRight) {
      this.uiRight.remove();
      this.uiRight = null;
    }
  },

  makeWiFiNetworks: function () {
    defineCss('.connected', 'color: #1AC876;');
    defineCss('.ssid', 'display:flex; flex-direction: column;');

    const lThis = this;
    const ui = [];

    Object.keys(this.options).forEach(function (pOption) {
      const connected = lThis.options[pOption].data.connected;
      const lOption = $('<div class="app-option">').append(
        $('<div class="app-option-selector">').css({ height: '100%' }),
        $('<div class="ssid">')
          .css({ padding: '0.5rem' /*, 'font-weight': 700 */ })
          .append(
            $('<div>')
              .text(pOption)
              .css({
                'text-overflow': 'ellipsis',
                overflow: 'hidden',
                'white-space': 'nowrap',
                width: '100%',
                'font-weight': 700,
              }),
            $(`<div id="ssid_connected" style="font-size:14px;" ${connected ? ' class="connected"' : ''}>`).text(connected ? 'Connnected' : 'Not connected'),
          ),
        $('<i class="icon-network app-option-icon">').css({ 'font-size': '1rem' }),
      );
      lOption.click(function () { lThis.selectOption(pOption); });
      ui.push(lOption);
      lThis.options[pOption].ui = lOption;
    });

    return ui;
  },

  isScanning: false,

  scanWifi: function () {
    if (this.isScanning) { return; }

    this.options = {};
    this.isScanning = true;
    this.selectedSsid = null;

    this.uiLeft.find('#wifi_networks').empty();
    this.uiLeft.find('#wifi_wait').addClass('rotate');
    this.show();

    MachineMotionApi.wifi.networks((data) => {
      // Request was successful, process response
      if (data && data.networks) {
        // Filter ssid to remove duplicates (same network on different frequencies)
        const ssid = [];
        const networks = [];
        data.networks.forEach(function (el) {
          if (ssid.includes(el.ssid)) { return; }
          ssid.push(el.ssid);
          networks.push(el);
          // Add a connected attribute to scanned networks
          el.connected = el.ssid == data.currentWifiSsid;
          el.encryption = el.encryption == 'on';
        });
        if (data.currentWifiSsid) {
          // Make it to the top (switch positions)
          networks.sort(function (a, b) {
            if (a.connected) { return -1; }
            if (b.connected) { return 1; }
            return 0;
          });
        }
        this.update('onScan', networks);
      }
      else {
        messageBox('Error while scanning available WiFi networks', 'error');
        this.update('onScan', []);
      }

      this.isScanning = false;
    },
    () => {
      this.isScanning = false;
      messageBox('Error while scanning available WiFi networks', 'error');
      this.update('onScan', []);
    },
    );
  },

  makeRefreshButton: function () {
    defineCss('.rotate', '-webkit-animation: spin 1.5s ease infinite; animation: spin 1.5s ease infinite;');
    const shouldRotate = this.isScanning;
    const ui = $('<div>')
      .css({
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        cursor: 'pointer',
        border: '1px solid #EFF2F7',
        'font-size': '16px',
      })
      .append(
        $('<div id="wifi_wait" class="icon-redo' + (shouldRotate ? ' rotate' : '') + '" style="margin-left:5px; display:inline-block;">'),
        $('<div>').text('Refresh networks').css({ padding: '10px', 'text-decoration': 'underline' }),
      )
      .click(() => {
        messageBox('Scanning available WiFi networks...', 'info');
        this.scanWifi();
      });

    ui.enable = (enable) => {
      if (enable) { ui.css({ cursor: 'pointer', opacity: '', 'pointer-events': 'auto' }); }
      else { ui.css({ cursor: 'not-allowed', opacity: '25%', 'pointer-events': 'none' }); }
    };

    return ui;
  },

  makeLeftUi: function () {
    const ui = makeButton(this.name, true);

    ui.find('.app-button-title').click(() => { this.collapse(this.uiLeft); });
    if (this.isAvailable()) {
      this.refreshButton = this.makeRefreshButton();
      ui.find('.app-options')
        .css({ display: 'none' })
        .append(
          this.refreshButton,
          $('<div id="wifi_networks">').append(this.makeWiFiNetworks()),
        );
    }
    else {
      ui.find('.app-options')
        .css({
          cursor: 'pointer',
          'font-size': '16px',
          'border-left': '1px solid #EFF2F7',
          'border-right': '1px solid #EFF2F7',
          'border-bottom': '1px solid #EFF2F7',
          'border-radius': '0 0 3px 3px',
          display: 'none',
        })
        .append(
          $('<div class="network-bold">').text('Wifi Not Available').css({ padding: '10px' }),
          $('<div>')
            .text('Please connect a Teach Pendant to enable WiFi connectivity.')
            .css({ padding: '10px', 'padding-top': '0px', color: '#88979B' }),
        );
    }

    // if the menu was expanded, restore it
    if (!this.collapsed) {
      this.collapsed = true;
      this.collapse(ui);
    }

    return ui;
  },

  init: function (pLeft, pRight, pApps) {
    this.rightPane = pRight;
    this.apps = pApps;
    this.uiLeft = this.makeLeftUi();
    pLeft.append(this.uiLeft);
  },

  select: function () {
    this.uiLeft.addClass('selected');
    this.uiLeft.find('.app-button-title').addClass('selected');
    this.isSelected = true;
  },

  deselect: function () {
    this._remove();
    this.uiLeft.removeClass('selected');
    this.uiLeft.find('.app-button-title').removeClass('selected');
    this.uiLeft.find('.app-option').removeClass('selected');
    this.isSelected = false;
  },

  collapse: function (ui) {
    this.collapsed = !this.collapsed;
    ui.find('.app-options').css({ display: this.collapsed ? 'none' : 'flex' });
    if (this.collapsed) {
      ui.find('.app-button-title').removeClass('expanded');
      ui.find('.app-button-title > span').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
    else {
      ui.find('.app-button-title').addClass('expanded');
      ui.find('.app-button-title > span').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
  },

  getConnected: function () {
    const connected = Object.keys(this.options).find((name) => {
      return this.options[name].data.connected;
    });
    return connected;
  },

  isConnected: function () {
    return !!Object.keys(this.options).find(ssid => this.options[ssid].data.connected);
  },

  cancelPolling: function () {
    this.pollingCancellation?.();
    this.pollingCancellation = null;
  },

  update: function (type, data) {
    const lThis = this;

    let needUpdateRight = false;
    let needUpdateLeft = false;

    function updateConnectionUI () {
      Object.keys(lThis.options).forEach(function (pOption) {
        const lState = lThis.options[pOption].ui.find('#ssid_connected');
        if (lThis.options[pOption].data.connected) {
          lState.addClass('connected');
          lState.text('Connected');
        }
        else {
          lState.removeClass('connected');
          lState.text('Not connected');
        }
      });
    }

    function disconnectAll () {
      Object.keys(lThis.options).forEach(function (pOption) {
        lThis.options[pOption].data.connected = false;
      });
    }

    function updateOptions (pNetworks) {
      /*  pNetworks should be: [ { ssid : String, encryption : String|none, connected : true|false } ] */
      lThis.options = {};
      pNetworks.forEach(pNetwork => {
        lThis.options[pNetwork.ssid] = { data: pNetwork, ui: null };
      });
      lThis.uiLeft.find('#wifi_networks').empty().append(lThis.makeWiFiNetworks());
    }

    switch (type) {
      case 'pendantWlan':
        /* data should be : { ssid: "someName", ip: "192.168.23.23", gateway: "192.128.0.1" } */
        // We are connected to a Wifi network
        if (data.ssid && this.options[data.ssid]) { // we might not yet have finished to scan yet
          if (this.options[data.ssid].data.ip != data.ip) {
            this.options[data.ssid].data.ip = data.ip;
            needUpdateRight = true;
          }
          if (this.options[data.ssid].data.netmask != data.netmask) {
            this.options[data.ssid].data.netmask = data.netmask;
            needUpdateRight = true;
          }
          if (this.options[data.ssid].data.gateway != data.gateway) {
            this.options[data.ssid].data.gateway = data.gateway;
            needUpdateRight = true;
          }

          if (!this.options[data.ssid].data.connected) {
            this.options[data.ssid].data.connected = true;
            needUpdateLeft = true;
            needUpdateRight = true;
          }

          if (data.ssid != this.selectedSsid) { needUpdateRight = false; }
        }
        // We are NOT connected to a Wifi network ANYMORE, let's update the data and clear everything.
        else if (this.getConnected()) { // Note : getConnected is used for "isConnected" purposes
          disconnectAll();
          needUpdateRight = true;
          needUpdateLeft = true;
        }
        break;

      case 'onScan':
        /* data should be: [ { ssid : String, encryption : String|none, connected : true|false } ] */
        this.uiLeft.find('#wifi_wait').removeClass('rotate');
        updateOptions(data);
        break;

      case 'onConnect':
        /* data should be: String */
        disconnectAll();

        if (this.options[data]) { this.options[data].data.connected = true; }
        else { console.error(`was trying to connect to ${data}, but it does not exist in the reported networks`); }

        needUpdateRight = true;
        needUpdateLeft = true;
        break;

      case 'onDisconnect':
        /* data should be: undefined */
        disconnectAll();
        needUpdateRight = true;
        needUpdateLeft = true;
        break;
      case 'onAvailable': {
        /* data should be: true | false */
        const isWifiAvailable = data;
        const hasNetworkConnectivityChanged = this.isWifiAvailable !== isWifiAvailable;
        this.isWifiAvailable = isWifiAvailable;

        if (isWifiAvailable) {
          this.scanWifi();

          if (!this.pollingCancellation) {
            this.pollingCancellation = pollNetworkInfo(
              'pendantWlan',
              5000,
              jsonResponse => this.update('pendantWlan', JSON.parse(jsonResponse)),
            );
          }
        }
        else {
          this.cancelPolling();
          this.selectedSsid = null;
          messageBox('Lost Teach Pendant connection.', 'warning');
        }

        if (hasNetworkConnectivityChanged) {
          const ui = this.makeLeftUi();
          this.uiLeft.replaceWith(ui);
          this.uiLeft = ui;
          needUpdateRight = true;
        }
        break;
      }
      default:
        console.warn('_networkWifiApp.update -- Not supported update type : ' + type);
        break;
    }

    if (needUpdateRight && this.uiRight) { this.show(); }
    if (needUpdateLeft) { updateConnectionUI(); }
    if (needUpdateRight || needUpdateLeft) { if (this.onChangeCb) { this.onChangeCb(); } }
    if (this.onUpdateCb) { this.onUpdateCb(type, data); }
  },
};

/**
 * Polls the specified network at a set interval.
 * Polling will continue on error.
 * If you want to stop polling when error occur, provide an error callback that calls the cancellation callback.
 *
 * @param {NetworkNames} networkName The network to poll.
 * @param {number} intervalMs The interval in milliseconds between requests.
 * @param {(jsonResponse: string) => void} onSuccess A callback for when we get a polling result.
 * @param {(xhr: XMLHttpRequest, status: string, error: string) => void} [onError] A callback for when a request fails.
 * @return {() => void} A function to stop polling.
 */
function pollNetworkInfo (networkName, intervalMs, onSuccess, onError = undefined) {
  let networkInfoRequestCancellation = null;
  let requestTimeout = null;

  function poll () {
    networkInfoRequestCancellation = MachineMotionApi.getNetworkInfo(
      networkName,
      jsonResponse => {
        onSuccess(jsonResponse);
        requestTimeout = setTimeout(poll, intervalMs);
      },
      (xhr, status, error) => {
        onError?.(xhr, status, error);
        requestTimeout = setTimeout(poll, intervalMs);
      },
    );
  }

  poll();

  return () => {
    networkInfoRequestCancellation?.();
    clearTimeout(requestTimeout);
  };
}

export default wifiApp;
